<div class="login-container">
    <app-exam-header [pageTitle]="'Login'"></app-exam-header>
    <div class="login-content-wrapper">
        <div class="login-row">
            <!-- Left side - Image section -->
            <div class="login-image-section">
                <div class="image-content">
                    <img src="../../../../assets/images/login.png" alt="Profile Illustration">
                </div>
            </div>
            
            <!-- Right side - Login form section -->
            <div class="login-form-section">
                <div class="login-form-wrapper">
                    <div class="login-form-header">
                        <h2>Welcome Back</h2>
                        <p>Sign in to continue</p>
                    </div>
                    
                    <form [formGroup]="loginForm" class="responsive-form">
                        <div class="form-group">
                            <mat-form-field appearance="outline">
                                <mat-label>Email</mat-label>
                                <mat-icon matPrefix>person</mat-icon>
                                <input matInput formControlName="username" autocomplete="off">
                                <mat-error *ngIf="loginForm.get('username').hasError('required')">
                                    Username is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        
                        <div class="form-group">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Password</mat-label>
                                <mat-icon matPrefix class="form-icon">lock</mat-icon>
                                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="off">
                                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword" class="visibility-icon">
                                    <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                                <mat-error *ngIf="loginForm.get('password').hasError('required')">
                                    Password is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        
                        <div class="remember-forgot">
                            <mat-checkbox color="primary" (click)="rememberMe()" class="remember-checkbox">Remember me</mat-checkbox>
                            <a routerLink="/forgot-password" class="forgot-link">Forgot password?</a>
                        </div>
                        
                        <div class="form-actions">
                            <button class="login-btn" (click)="SFLogin()">
                                <span>Sign In</span>
                                <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </div>
                        
                        <div class="form-footer">
                            <p>Don't have an account? <a routerLink="/signup">Create Account</a></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <app-exam-footer class="footer"></app-exam-footer>
</div>